import { format, parseISO } from "date-fns";

/** Individual display parts parsed from an appointment ISO timestamp. */

/** Splits an ISO timestamp into the four display parts used by the appointment date box. */
export function getAppointmentDateParts(iso) {
  try {
    var date = parseISO(iso);
    return {
      day: format(date, "d"),
      month: format(date, "MMM"),
      year: format(date, "yyyy"),
      time: format(date, "h:mm a")
    };
  } catch (_unused) {
    return {
      day: "--",
      month: "--",
      year: "--",
      time: "--"
    };
  }
}